import { graphql } from "react-relay";

export const COMMIT_LINEUP_EDITS = graphql`
  mutation CommitLineupEditsMutation($input: CommitLineupEditsInput!) {
    commitLineupEdits(input: $input) {
      success
    }
  }
`;
